import { IconBase, type IconProps } from './iconBase';

import type { JSX } from 'react';

export const Code = ({ type, ...rest }: IconProps): JSX.Element => (
  <IconBase viewBox='0 0 24 24' {...rest}>
    {type === 'stroke' ? (
      <path
        d='m9.75 20.25 4.5-16.5m4 4 2.71 2.88a2 2 0 0 1 0 2.74l-2.71 2.88m-12.5 0-2.71-2.88a2 2 0 0 1 0-2.74l2.71-2.88'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    ) : (
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M14.447 3.027a.75.75 0 0 1 .527.92l-4.5 16.5a.75.75 0 0 1-1.448-.394l4.5-16.5a.75.75 0 0 1 .921-.526M6.264 7.204a.75.75 0 0 1 .032 1.06l-2.71 2.88a1.25 1.25 0 0 0 0 1.713l2.71 2.88a.75.75 0 1 1-1.092 1.027l-2.71-2.879a2.75 2.75 0 0 1 0-3.77l2.71-2.879a.75.75 0 0 1 1.06-.032m11.472 0a.75.75 0 0 1 1.06.032l2.71 2.88a2.75 2.75 0 0 1 0 3.769l-2.71 2.88a.75.75 0 0 1-1.092-1.029l2.71-2.88a1.25 1.25 0 0 0 0-1.713l-2.71-2.879a.75.75 0 0 1 .032-1.06'
        fill='currentColor'
      />
    )}
  </IconBase>
);
